import { motion } from 'framer-motion'
import React from 'react'

const animations = {
    initial: { opacity: 0, x: -10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 0 }
}
/**
 * The function returns a React component that applies animated page fade transitions to its children.
 * @returns a JSX element. Specifically, it is returning a `<motion.div>` element from the Framer
 * Motion library, which has the provided `variants`, `initial`, `animate`, `exit`, and `transition`
 * props. The `children` prop is also being rendered within the `<motion.div>` element.
 */
export default function AnimatedPageFade({ children, className }) {
    return (
        <motion.div
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            className={className || ''}
            transition={{ duration: 0.5, type: "fade" }}>
            {children}
        </motion.div>
    )
}
